@if(initialized) {

  <otp
    (onConfirmOtp)="handleConfirmOtp($event)"
    (onRequestOtp)="handleRequestOtp($event)"
  >
  </otp>

}
